<template>
  <div class="new-field">
    <div class="d-flex">
      <input v-model="id" ref="id" :placeholder="idPlaceholder">
      <input v-model="label" :placeholder="labelPlaceholder">
      <button class="save" @click="save">
        Save
      </button>
      <button @click="$emit('cancel')">
        Cancel
      </button>
    </div>
    <div v-if="(examplePrefix || exampleSuffix) && id" class="example">
      <div v-if="(examplePrefix || exampleSuffix)">
        CSS class result: <span class="code" :class="{error: !isValidClassName}">{{ (examplePrefix || '') + id + (exampleSuffix || '') }}</span>
      </div>
      <span v-if="id && !isValidClassName" class="error">The 'id' must be a valid CSS class name.</span>
    </div>
  </div>
</template>

<script>

export default {
  props: ['examplePrefix', 'exampleSuffix', 'idPlaceholder', 'labelPlaceholder'],
  data() {
    return {
      id: "",
      label: "",
    }
  },
  mounted() {
    this.$refs.id.focus()
  },
  methods: {
    save() {
      if (!this.id || !this.label) return this.$error("You must provide an id and a label.")
      if (!this.isValidClassName) return this.$error("Please fix all form errors.")
      this.$emit("save", {id: this.id, label: this.label})
    },
  },
  computed: {
    isValidClassName() {
      return this.id && this.id.indexOf(' ') <= 0 && /-?(?:[_a-z]|[\200-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])(?:[_a-z0-9-]|[\200-\377]|\\[0-9a-f]{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])*/.test(this.id)
    },
  },
}

</script>

<style scoped>

button {
  border-left: 1px solid #E3E3E3;
  font-weight: 600;
  padding: 0 10px;
}

button:hover {
  color: var(--red);
}

.save:hover {
  color: var(--primary);
}

.new-field {
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
}

.example {
  padding: 8px;
  font-size: 11px;
  border-top: 1px solid #E3E3E3;
  background-color: rgba(248,248,248);
}

.error {
  color: var(--red);
}

.code {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

input {
  padding: 8px;
  flex-basis: 50%;
  width: 50%;
}

input + input {
  border-left: 1px solid #E3E3E3;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

</style>
